export default __webpack_public_path__ + "static/mcbeth-a4fa32304a35ee274a1ab0859a794a06.jpg";